import { render } from "./TheTermometer.vue?vue&type=template&id=536cfb83&scoped=true"
import script from "./TheTermometer.vue?vue&type=script&lang=js"
export * from "./TheTermometer.vue?vue&type=script&lang=js"

import "./TheTermometer.vue?vue&type=style&index=0&id=536cfb83&scoped=true&lang=css"

import exportComponent from "/home/guilh/Milhagem/Telemetria/dt2-telemetria-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536cfb83"]])

export default __exports__